import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

const TagType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
});

class DeviceTags extends React.PureComponent {
  static get propTypes() {
    return {
      emptyValue: PropTypes.node,
      hideSystemTags: PropTypes.bool,
      tags: PropTypes.arrayOf(TagType),
      tagsUrlRoot: PropTypes.string,
    };
  }

  static get defaultProps() {
    return {
      emptyValue: null,
      tags: [],
      tagsUrlRoot: "/tags/",
    };
  }

  _sort(tags) {
    if (tags) {
      return tags.sort((first, second) => {
        const fname = first.name;
        const sname = second.name;
        // System tags should be ordered first.
        const fsys = fname && fname[0] === "_";
        const ssys = sname && sname[0] === "_";
        if (fsys && !ssys) {
          return -1;
        } else if (!fsys && ssys) {
          return 1;
        }
        return fname.localeCompare(sname);
      });
    }
    return tags;
  }

  render() {
    const {
      emptyValue,
      hideSystemTags,
      tagsUrlRoot,
      tags: unsortedTags,
    } = this.props;
    const tags = this._sort(unsortedTags);
    const links = [];

    tags.forEach((tag) => {
      let color;
      if (tag.name[0] === "_") {
        if (hideSystemTags) {
          return;
        }
        color = "aqua";
      } else {
        color = "maroon";
      }

      links.push(
        <Link key={tag.id} to={`${tagsUrlRoot}${tag.id}`}>
          <span className={`label bg-${color} disabled label-spacer`}>
            {tag.name}
          </span>
        </Link>,
      );
    });

    return (
      <span className="device-tag-list">
        {links.length ? links : emptyValue}
      </span>
    );
  }
}

export default DeviceTags;
export { DeviceTags };
